const MapTemplates = {
  normal: undefined,
  openMap: '5a4364dfb221246bdceb4acb',
  aliasMap: '5f2f80bfcb8cdca929c3e77c',
  spotCollectionMap: '5f2f80bfcb8cdca929c3e77e'
};

export default {
  isCurrentMapAlias: () =>
    (window.Gdata.CurrentMap.ori[0].template_id === MapTemplates.aliasMap || window.Gdata.CurrentMap.ori[0].template_id === MapTemplates.spotCollectionMap),
  isCurrentOnlyMapAlias: () =>
    (window.Gdata.CurrentMap.ori[0].template_id === MapTemplates.aliasMap),
  /**
   * check if team member
   * exclude map owner
   */
  isSessionUserInMapGroup: () => {
    const map = window.Gdata.CurrentMap.ori[0];

    // map owner
    if (map.session_account_id === map.account_id) {
      return false;
    }

    return !!map.mapGroups.find(
      (group) => group.account_id === map.session_account_id
    );
  },
};
